<template class="telaQuestionarioRisco">
  <v-container grid-list-md class="gridList pt-0">
    <v-layout row wrap class="pt-0">
      <v-flex xs12 md3 class="menuSteps">
        <v-layout class="logoApisul pa-2">
          <v-flex xs12 md3>
            <img
              class="logo pointer d-flex align-center img-logo" style="width:234px; fill-rule:evenodd;fill: black !important; stroke:#000; stroke-miterlimit:10;" height="30px"
              :src="require('@/assets/logo-apisulseguros.svg')"
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-toolbar-side-icon class="side-icon" v-show="$vuetify.breakpoint.xs" @click="navigationDrawer = !navigationDrawer" />
        </v-layout>
        <v-navigation-drawer
          stateless
          class="navigation-drawer-custom"
          style="width:100%"
          value="true"
          v-show="!$vuetify.breakpoint.xs || navigationDrawer"
        >
          <v-list class="pt-0 pb-0">
            <v-list-group
              value="true"
              class="group-list-dados-cadastrais pt-0 pb-0"
              v-model="drawer"
            >
              <template v-slot:activator>
                <v-list-tile @click="etapaTratativa = false">
                  <v-list-tile-title class="body-2"
                    >Questionário de Análise de Risco</v-list-tile-title
                  >
                </v-list-tile>
              </template>
              <v-stepper
                v-if="idQuestionario"
                class="custom-stepper"
                :vertical="true"
                v-model="etapa"
              >
                <v-stepper-step complete editable step="1">
                  Dados Cadastrais
                </v-stepper-step>
                <v-stepper-step complete editable step="2">
                  Endereço
                </v-stepper-step>
                <v-stepper-step complete editable step="3">
                  Dados Operacionais
                </v-stepper-step>
                <v-stepper-step complete editable step="4">
                  Rotas Percorridas
                </v-stepper-step>
                <v-stepper-step complete editable step="5">
                  Mercadorias Transportadas
                </v-stepper-step>
                <v-stepper-step complete editable step="6">
                  Clientes Averbados
                </v-stepper-step>
                <v-stepper-step complete editable step="7">
                  Dados da Frota
                </v-stepper-step>
                <v-stepper-step complete editable step="8">
                  DDRs e Detalhes da Operação
                </v-stepper-step>          
                <v-stepper-step complete editable step="9">
                  Condições do segurado
                </v-stepper-step>
                <v-stepper-step complete editable step="10">
                  Proposições Comerciais
                </v-stepper-step>
              </v-stepper>
              <v-stepper
                v-else
                class="custom-stepper"
                :vertical="true"
                v-model="etapa"
              >
                <v-stepper-step :complete="etapa > 1" step="1">
                  Dados Cadastrais
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 2" step="2">
                  Endereço
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 3" step="3">
                  Dados Operacionais
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 4" step="4">
                  Rotas Percorridas
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 5" step="5">
                  Mercadorias Transportadas
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 6" step="6">
                  Clientes Averbados
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 7" step="7">
                  Dados da Frota
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 8" step="8">
                  DDRs e Detalhes da Operação
                </v-stepper-step>          
                <v-stepper-step :complete="etapa > 9" step="9">
                  Condições do segurado
                </v-stepper-step>
                <v-stepper-step :complete="etapa > 10" step="10">
                  Proposições Comerciais
                </v-stepper-step>
              </v-stepper>
            </v-list-group>
            <v-btn
              block
              class="btn-custom-qar option"
              @click="ativarTratativa"
              :disabled="!disableTratativas"
              >Tratativas</v-btn
            >
            <v-btn
              block
              class="btn-custom-qar option"
              :disabled="!disableAnexos"
              @click="ativarAnexos"
              >Anexos</v-btn
            >
            <v-btn block class="btn-custom-qar" 
            color="primary" 
            @click="go('ListagemSolicitacoes')"
              >Retornar ao Quadro de Cotações
            </v-btn>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 md8>
        <v-stepper class="mt-4" vertical v-model="etapa" v-show="!ativarEtapasQuestionario">
          <v-stepper-items>
            <v-stepper-content class="stepperContentCustom" step="1">
              <QARDadosCadastrais
                @dadosCadastrais="getDadosCadastrais"
                @nomeUsuarioAutor="getNomeAutor"
                @razaoSocialTrasnportadora="getRazaoSocialTrasnportadora"
                :dadosQuestionario="questionarioCompleto"
                @dadosEnviados="dadosTratativaRecebido = true"
                @dadosTransportadoroBusca="tratamentoDadosTransportadora"
                v-bind="stepsProtocolo"
              ></QARDadosCadastrais>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="2">
              <QAREndereco
                @voltarEndereco="etapa = 1"
                @dadosEndereco="getDadosEndereco"
                :dadosTransportadoraCompleto="dadosCompletoTransportadora"
                v-bind="stepsProtocolo"
              ></QAREndereco>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="3">
              <QARDadosOperacionais
                :dadosQuestionarioCompleto="questionarioCompleto"
                @voltarDadosOperacionais="etapa = 2"
                @dadosOperacionais="getDadosOperacionais"
                v-bind="stepsProtocolo"
              ></QARDadosOperacionais>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="4">
              <QARRotasPercorridas
                @voltarRotasPercorridas="etapa = 3"
                :dadosQuestionarioCompleto="questionarioCompleto"
                @dadosRotasPercorridas="getDadosRotasPercorridas"
                v-bind="stepsProtocolo"
              ></QARRotasPercorridas>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="5">
              <QARMercadoriasTransportadas
                @voltarMercadoriasTransportadas="etapa = 4"
                :dadosQuestionarioCompleto="questionarioCompleto"
                @dadosMercadoriasTransportadas="getDadosMercadoriasTransportadas"
                v-bind="stepsProtocolo"
              ></QARMercadoriasTransportadas>
            </v-stepper-content>        
            <v-stepper-content class="stepperContentCustom" step="6">
              <QARClientesAverbados
                @voltarClientesAverbados="etapa = 5"
                :dadosQuestionarioCompleto="questionarioCompleto"
                @dadosClientesAverbados="getDadosClientesAverbados"
                v-bind="stepsProtocolo"
              ></QARClientesAverbados>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="7">
              <QARDadosFrota
                @voltarDadosFrota="etapa = 6"
                :dadosQuestionarioCompleto="questionarioCompleto"
                @dadosFrota="getDadosFrota"
                v-bind="stepsProtocolo"
              ></QARDadosFrota>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="8">
              <QARDDR
                @voltarDetalhesOperacao="etapa = 7"
                :dadosQuestionarioCompleto="questionarioCompleto"
                :dadosCadastrais="dadosCadastrais"
                @dadosDetalhesOperacao="getDadosDetalheOperacao"
                v-bind="stepsProtocolo"
              ></QARDDR>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="9">
              <QARCondicoesSegurado
                @voltarSeguroAnterior="etapa = 8"
                @dadosSeguroAnterior="getDadosSeguroAnterior"
                :dadosQuestionarioCompleto="questionarioCompleto"
                :dadosCadastrais="dadosCadastrais"
                v-bind="stepsProtocolo"
              ></QARCondicoesSegurado>
            </v-stepper-content>
            <v-stepper-content class="stepperContentCustom" step="10">
              <QARProposicoesComerciais
                @voltarProposicoesComerciais="etapa = 9"
                :dadosQuestionarioCompleto="questionarioCompleto"
                :dadosCadastrais="dadosCadastrais"
                @dadosProposicoesComerciais="getDadosProposicoesComerciais"
                v-bind="stepsProtocolo"></QARProposicoesComerciais>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <Tratativas 
          :dadosQuestionarioCompleto="questionarioCompleto"
          v-bind="tratativas" v-show="etapaTratativa"
          ></Tratativas>
        <Anexos v-show="etapaAnexos"></Anexos>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
  
</template>

<script>
import QARDadosCadastrais from "./steps/QARDadosCadastrais.vue";
import QAREndereco from "./steps/QAREndereço.vue";
import QARDadosOperacionais from "./steps/QARDadosOperacionais";
import QARRotasPercorridas from "./steps/QARRotasPercorridas.vue";
import QARMercadoriasTransportadas from "./steps/QARMercadoriasTransportadas.vue";
import QARClientesAverbados from "./steps/QARClientesAverbados.vue";
import QARDadosFrota from "./steps/QARDadosFrota.vue";
import QARDetalhesOperacao from "./steps/QARDetalhesOperacao.vue";
import QARSeguroAnterior from "./steps/QARSeguroAnterior.vue";
import QARProposicoesComerciais from "./steps/QARProposicoesComerciais.vue";
import QARDDR from "./steps/QARDDR.vue";
import QARCondicoesSegurado from "./steps/QARCondicoesSegurado.vue";

import Tratativas from "./Tratativas.vue";
import Anexos from "./Anexos.vue";
import axios from 'axios'
import usuarioHelper from "@/helpers/usuario-logado";
export default {
  name: "QuestionarioAnaliseRiscos",
  components: {
    QARDadosCadastrais,
    QAREndereco,
    QARDadosOperacionais,
    QARRotasPercorridas,
    QARMercadoriasTransportadas,
    QARClientesAverbados,
    QARDadosFrota,
    QARDetalhesOperacao,
    QARSeguroAnterior,
    QARProposicoesComerciais,
    Tratativas,
    Anexos,
    QARDDR,
    QARCondicoesSegurado,
},
  data: () => ({
    dadosTratativaRecebido: false, 
    nomeRazaoSocialTrasnportadora: null,
    nomeUsuarioAutor: null, 
    questionarioCompleto: {},
    idQuestionario: null, 
    etapaAnexos: false, 
    protocolo: null,
    dadosCompletoTransportadora: {},
    abrirTelaAnexos: false,
    stepsProtocolo: {},
    etapa: 1,
    disableTratativas: false,
    disableAnexos: false,
    dadosCadastrais: {},
    navigationDrawer: false,
    drawer: true,
    enviando: false,
    etapaTratativa: false,
    dadosEndereco: {},
    dadosOperacionais: {},
    dadosRotasPercorridas: {},
    dadosMercadoriasTransportadas: {},
    dadosClientesAverbados: {},
    dadosFrota: {},
    dadosDetalhesOperacao: {},
    dadosSeguroAnterior: {},
    dadosTratativas: {},
    tratativas: {
      autor: null, 
      protocolo: null,
      nomeTransportador: null,
      dataAbertura: null,
      model: new Date(),
      lstStatus: null
    },
    questionarioModel: null,
    dadosProposicoesComerciais: {},
    idTransportadora: null,
    snack: false,
    snackColor: "",
    snackText: "",
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    }
  }),
  watch: {
    dadosTratativaRecebido(val) {
      if(val) {
        this.tratativas.protocolo =  this.questionarioCompleto.protocolo;
        this.tratativas.nomeTransportador = this.nomeRazaoSocialTrasnportadora;
        this.tratativas.dataAbertura = this.questionarioCompleto.dataCriacao;
        this.tratativas.autor = this.nomeUsuarioAutor;
        this.tratativas.model = this.questionarioCompleto;
      }
    }
  },
  mounted: async function () {
    this.$store.commit("startLoading");
    await this.carregaStatusList();
    this.idQuestionario = this.$route.query.id;
    if(this.idQuestionario) {
      this.buscarQuestionario();
    }
   
    this.$store.commit("endLoading");
  },
  computed: {
    ativarEtapasQuestionario() {
      return this.etapaAnexos || this.etapaTratativa
    },
  },
  methods: {
    getNomeAutor(val) {
      if(val) {
        this.tratativas.autor = val;
      }
    },
    getRazaoSocialTrasnportadora(val) {
      if(val) {
        this.tratativas.nomeTransportador = val;
      }
    },
    
    tratamentoDadosTransportadora(value) {
      if(value) {
        this.dadosCompletoTransportadora = value;
      }
    },
    buscarQuestionario() {
      axios.get(
        `${process.env.URL_QUESTIONARIOMS}/v1/buscaQuestionario?id=${this.idQuestionario}`, {
          headers: { Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
        }
      ).then(response => {
        if(response.data) {
          this.questionarioCompleto = response.data;
          this.etapaTratativa = true;
          this.drawer = false;
          this.disableTratativas = true;
          this.disableAnexos = true;
        }
      }).catch(err => {
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "Ocorreu um erro ao tentar buscar as informações do questionário.";
        this.snackbar.visivel = true;
      })
    },
    ativarAnexos() {
      if(this.drawer) {
        this.drawer = false;
      }
      this.drawer = !this.drawer;
      this.etapaTratativa = false;
      this.etapaAnexos = !this.etapaAnexos;
    },
    getDadosCadastrais(value) {
      if (value) {
        this.dadosCadastrais = value;
        this.etapa = 2;
      }
    },
    go: function(routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({name: routeName});
      } else {
        self.$router.push({name: routeName, params: routeParams});
      }
    },
    getDadosEndereco(value) {
      if (value) {
        this.dadosEndereco = value;
        this.etapa = 3;
      }
    },
    getDadosOperacionais(value) {
      if (value) {
        this.dadosOperacionais = value;
        this.etapa = 4;
      }
    },
    getDadosRotasPercorridas(value) {
      if (value) {
        this.dadosRotasPercorridas = value;
        this.etapa = 5;
      }
    },
    getDadosMercadoriasTransportadas(value) {
      if (value) {
        this.dadosMercadoriasTransportadas = value;
        this.etapa = 6;
      }
    },
    getDadosClientesAverbados(value) {
      if (value) {
        this.dadosClientesAverbados = value;
        this.etapa = 7;
      }
    },
    getDadosFrota(value) {
      if (value) {
        this.dadosFrota = value;
        this.etapa = 8;
      }
    },
    getDadosDetalheOperacao(value) {
      if (value) {
        this.dadosDetalhesOperacao = value;
        this.etapa = 9;
      }
    },
    getDadosSeguroAnterior(value) {
      if (value) {
        this.dadosSeguroAnterior = value;
        this.etapa = 10;
      }
    },

    getDadosTratativas(value) {
      if (value) {
        this.dadosTratativas = value;
        this.etapa = 11;
      }
    },

    ativarTratativa(){
      this.drawer = false;
      this.etapaAnexos = false;
      this.etapaTratativa = !this.etapaTratativa;
    },

    getDadosProposicoesComerciais(value) {
      if (value) {
        this.dadosProposicoesComerciais = value;
        this.disableTratativas = true;
        this.disableAnexos = true;
        this.enviaQuestionario()
      }
    },
    async enviaQuestionario() {
      const self = this;
      let modeloQuestionario = {};
      let modeloTransportadora = {};
      self.loadingEnvio = true;
      if(!this.enviando){
        this.enviando = true 
      this.objetoDadosTransportadora(modeloTransportadora);
      await axios
        .post(
          `${process.env.URL_TRANSPORTADORAMS}/v1/salvaTransportadora`,
          modeloTransportadora, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
        )
        .then(response => {
          this.save();
          self.idTransportadora = response.data.id;
          var exception = response.data.apisulBusinessException;
          this.enviando = false;
        })
        .catch(err => {
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao enviar sua solicitação";
          self.snackbar.visivel = true;
          self.loadingEnvio = false;
          this.enviando = false;
        });

      this.objetoDadosOperacionais(modeloQuestionario),

      axios
        .post(
          `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/insereQuestionario?qar=1`,
          modeloQuestionario, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
        )
        .then(response => {
          this.save();
          self.protocolo = response.data.protocolo;
          var exception = response.data.apisulBusinessException;
          axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaQuestionarioPorProtocolo?protocolo=${self.protocolo}`,
          {
            headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then((response) => {
            self.questionarioModel = response.data;
          })
          this.stepsProtocolo = {
            protocolo: this.protocolo
          }
          self.loadingEnvio = false;
          this.enviando = false;
          setTimeout(() => {
            this.tratativas.protocolo = this.protocolo
            this.tratativas.nomeTransportador = this.dadosCadastrais.razaoSocial;
            this.tratativas.dataAbertura = new Date().toISOString().slice(0, 10);
            this.tratativas.autor = usuarioHelper.USUARIO_LOGADO().nome;
            this.tratativas.model = this.questionarioModel;
            this.ativarTratativa();
          }, 3000);
        })
        .catch(err => {
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao enviar sua solicitação";
          self.snackbar.visivel = true;
          self.loadingEnvio = false;
          this.enviando = false;
        });
        }
    },

    carregaStatusList: async function () {
     
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaTodosStatusQuestionario`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(response => {
        this.tratativas.lstStatus = response.data
      });
    },

    usuarioSolicitante(){
      return {
        ddd: this.dadosCadastrais.ddd,
        telefone: this.dadosCadastrais.telefone,
        nome: this.dadosCadastrais.nome,
        email: this.dadosCadastrais.email
      }
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    objetoDadosTransportadora(modeloTransportadora) {

      modeloTransportadora.dadosCadastrais = {
        razaoSocial: this.dadosCadastrais.razaoSocial,
        cnpj: this.dadosCadastrais.transportadora.cnpj,
      },
      modeloTransportadora.dadosEndereco = {
        uf: this.dadosEndereco.uf,
        cidade: this.dadosEndereco.cidade
      }
      modeloTransportadora.tipoCliente = this.dadosCadastrais.transportadora.tipoCliente;
    },

    objetoDadosOperacionais(modeloQuestionario) {
      var valorTransportadoMes = this.dadosOperacionais.valorTransportadoMes
      var maiorValorEmbarcado = this.dadosOperacionais.valorMaximoTransportadoViagem

      for (var x of this.dadosSeguroAnterior.ramos) {
        x.posFranquia = x.posFranquia.toString();
      }
      
      modeloQuestionario.dadosOperacionais = {      
      valorTransportadoMes: parseInt(valorTransportadoMes),
      quantidadeViagensMes: this.dadosOperacionais.quantidadeViagensMes,
      maiorValorEmbarcado: parseInt(maiorValorEmbarcado),
      percentualVeiculoProprio: this.dadosOperacionais.percentualMesFrota.propria,
      percentualVeiculoAgregado: this.dadosOperacionais.percentualMesFrota.agregados,
      percentualVeiculoAutonomo: this.dadosOperacionais.percentualMesFrota.terceiros,
      fluvial: this.dadosDetalhesOperacao.fluvial== "true"? true: false,
      container: this.dadosDetalhesOperacao.container== "true"? true: false,
      imposto: this.dadosDetalhesOperacao.impostos== "true"? true: false,
      rotas: this.dadosRotasPercorridas,
      mercadorias: this.dadosMercadoriasTransportadas,
      averbados: this.dadosClientesAverbados,
      ddrEmbarcadorOpcao: this.dadosDetalhesOperacao.ddrEmbarcadorOpcao == "true"? true: false,
      ddrEmbarcador: this.dadosDetalhesOperacao.ddrEmbarcador,
      outrosOpcao: this.dadosFrota.outrosOpcao == "true" ? true : false,
      outrosTipos: this.dadosFrota.outrosTipos,
      tipoDocumento: this.dadosDetalhesOperacao.tipoDocumento,
      outroTipoDocumento: this.dadosDetalhesOperacao.outroTipoDocumento,
      veiculosFrota: this.dadosFrota.veiculosFrota
      },  
    
    modeloQuestionario.segurosAnteriores = {
      apolicesAnteriores: this.dadosSeguroAnterior.container,
      ocorreuSinistro: this.dadosSeguroAnterior.ocorreuSinistro,
      taxaApoliceAnterior: this.dadosSeguroAnterior.taxaApoliceAnterior,
      descontoApoliceAnterior: this.dadosSeguroAnterior.descontoApoliceAnterior,
      taxaRouboApoliceAnterior: this.dadosSeguroAnterior.taxaRouboApoliceAnterior,
      seguradora: this.dadosSeguroAnterior.seguradora,
      corretora: this.dadosSeguroAnterior.corretora,
      vencimento: this.dadosSeguroAnterior.vencimento,
      contrataCobertura: this.dadosSeguroAnterior.contrataCobertura,
      idCobertura: this.dadosSeguroAnterior.idCobertura,
      possuiCoberturaRoubo: this.dadosSeguroAnterior.possuiCoberturaRoubo,
      sinistros: this.dadosSeguroAnterior.sinistros,
      contrataServicos: this.dadosSeguroAnterior.contrataServicos,
      existeContrataServico: this.dadosSeguroAnterior.existeContrataServico,      
      existeRamosSegurado: this.dadosSeguroAnterior.ramos.length > 0 ? true : false,
      ramosSegurado: this.dadosSeguroAnterior.ramos,
      regraGerenciamento: this.dadosSeguroAnterior.regrasGerenciamento
    },
    modeloQuestionario.novoSeguro = {
      coberturaRoubo: false,
      taxaCoberturaRoubo: this.dadosProposicoesComerciais.descontoNovoSeguro == null ? 0.0 : this.dadosProposicoesComerciais.descontoNovoSeguro,
      descontoDesejado: this.dadosProposicoesComerciais.desconto,
      taxaDesejada: this.dadosProposicoesComerciais.taxa,
      contatos: null,
      dataInicioVigencia: this.dadosProposicoesComerciais.dataInicio,
      expectativa: this.dadosProposicoesComerciais.consideracao,
      tipoSeguro: this.dadosProposicoesComerciais.ramo,
   },
   modeloQuestionario.id = null,
   modeloQuestionario.idUsuarioSolicitante = this.dadosCadastrais.idUsuarioSolicitante, 
   modeloQuestionario.idUsuarioAutor = usuarioHelper.USUARIO_LOGADO().idUsuario,
   modeloQuestionario.solicitacaoInterna = false
   modeloQuestionario.idTransportadora = this.idTransportadora,
   modeloQuestionario.dataCriacao = new Date(),
   modeloQuestionario.ultimostatusupdate = new Date(),
   modeloQuestionario.grandeCotacao = false,
   modeloQuestionario.telaNova = true,
   modeloQuestionario.idTipoSolicitacao = usuarioHelper.USUARIO_LOGADO().idUsuario
    return modeloQuestionario
  }
  },
}

</script>

<style>
.QuestionarioAnaliseRiscos #menuToolbar {
  display: none;
}
.QuestionarioAnaliseRiscos#app {
  background: #fff;
}
.QuestionarioAnaliseRiscos .v-stepper__header {
  box-shadow: none !important;
}
.QuestionarioAnaliseRiscos .v-stepper {
  box-shadow: none !important;
}
.QuestionarioAnaliseRiscos .header-step h3 {
  color: #00456e;
  font-size: 22px;
  margin-bottom: 0;
}
.QuestionarioAnaliseRiscos .side-icon {
  color: #00456e;
}
.QuestionarioAnaliseRiscos .header-step p {
  color: #656565;
  font-size: 16px;
}

.QuestionarioAnaliseRiscos .v-list__group__header__append-icon{
  padding-right: 12px !important;
}

.QuestionarioAnaliseRiscos .v-stepper__step{
  padding: 8px !important;
  padding-left: 14px !important;
}
.QuestionarioAnaliseRiscos .custom-stepper.theme--light {
  background: #f2f2f2f2 !important;
  padding-top: 14px;
  padding-bottom: 14px;
  margin: 0 !important;
}
.QuestionarioAnaliseRiscos .v-content {
  padding-top: 0 !important;
}
.QuestionarioAnaliseRiscos .v-stepper__step--active .v-stepper__label,
.QuestionarioAnaliseRiscos .v-stepper__step--complete .v-stepper__label {
  color: #00456e !important;
}
.QuestionarioAnaliseRiscos .btn-custom-qar {
  margin: 0 !important;
  height: 50px;
}
.QuestionarioAnaliseRiscos .v-list__group__header--active {
  background-color: #d7d7d7 !important;
  height: 50px;
}
.QuestionarioAnaliseRiscos .v-list__group__header {
  background-color: #e0e0e0 !important;
  color: #555555;
}
.QuestionarioAnaliseRiscos .btn-custom-qar.option .v-btn__content {
  align-items: left !important;
  justify-content: left;
}

.QuestionarioAnaliseRiscos .menuSteps {
  max-width: 100%;
}

.QuestionarioAnaliseRiscos .v-stepper--vertical .v-stepper__content{
  margin: 0!important;
  border: none!important;
  padding: 0;
}

.QuestionarioAnaliseRiscos .stepperContentCustom {

    padding-top: 0!important;
}

.QuestionarioAnaliseRiscos .logoApisul {
  background-color: #f2f2f2f2;
  padding-top: 10px;
  margin: 0!important;
}

.QuestionarioAnaliseRiscos .v-stepper--vertical{
  padding-bottom: 10px;
}

.QuestionarioAnaliseRiscos .gridList {
  margin: 0!important;
  padding: 0!important;
}


.QuestionarioAnaliseRiscos img{
  margin-left: 12px;
  margin-top: 3px;
  padding: 0px !important;;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/QuestionarioAnaliseRiscos.vue